
  import {mapSectionComponents} from '@/helper/SectionHelper';
  import {getMetaTags} from '@/helper/Seo';
  import LazyHydrate from 'vue-lazy-hydration';
  import {scopeHelper} from '@/helper/ScopeHelper';
  import startCase from 'lodash/startCase';
  import axios from 'axios';

  export default {
    name: 'EventsCategory',
    components: {
      LazyHydrate,
    },
    async asyncData({route, error, $cachedStrapi, app, redirect, store}) {
      // Initialize variables
      const filterParams = {
        search_term: null,
        categories: [],
      };

      // Query page from Strapi; strapi-change for findOne is required!
      const pagePromise = $cachedStrapi
        .findOne('pages', 'events-category')
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }
        });

      // Query event-category from Strapi; strapi-change for findOne is required!
      const eventCategoryPromise = $cachedStrapi
        .findOne('event-categories', route.params.category)
        .catch(async () => {
          const slug = route.params.category;
          const readableSlug = startCase(slug.replace(/-/g, ' '));
          const currentQuery = route.query;
          const response = await axios.get(
            process.env.STRAPI_URL + '/event-categories',
            {
              params: {
                slug,
                _publicationState: 'preview',
              },
            }
          );
          if (response.data.length > 0) {
            const newQueryParam = {
              ...currentQuery,
              mtm_group: 'event-category-deactivated',
              search: readableSlug,
            };

            const redirectRoute = app.localePath({
              name: 'events',
              query: newQueryParam,
            });

            // Redirect the user to the main listing page (with status code 302)
            redirect(301, redirectRoute);
          } else {
            const newQueryParam = {
              ...currentQuery,
              mtm_group: 'event-category-not-found',
              search: readableSlug,
            };

            const redirectRoute = app.localePath({
              name: 'events',
              query: newQueryParam,
            });

            // Redirect the user to the main listing page (with status code 301)
            redirect(302, redirectRoute);
          }
          return;
        });

      const [page, eventCategory] = await Promise.all([
        pagePromise,
        eventCategoryPromise,
      ]);

      if (!scopeHelper(page, process.env.SCOPE_CANDIDATE)) {
        error({statusCode: 404, message: 'Page not found'});
        return;
      }
      if (!scopeHelper(eventCategory, process.env.SCOPE_CANDIDATE)) {
        error({statusCode: 404, message: 'Event not found'});
        return;
      }

      filterParams.categories = [eventCategory.slug];

      let search_url = '';
      if (store.getters['breadcrumbs/hasEventListingRoute']) {
        const lastEventListingRoute =
          store.state.breadcrumbs.lastEventListingRoute;

        search_url =
          app.localePath({
            name: 'events',
          }) +
          '?' +
          lastEventListingRoute.split('?')[1];
      }

      const sections = await mapSectionComponents(
        page.sections,
        async function (section) {
          switch (section.component) {
            case 'SectionEventListingWithFilter':
              section.filterParams = filterParams;
              section.content_scope = process.env.SCOPE_CANDIDATE;
              break;

            case 'SectionBreadcrumbs':
              section.breadcrumbs = [
                {
                  text: app.i18n.t('page.index'),
                  disabled: false,
                  to: app.localePath({
                    name: 'index',
                  }),
                  nuxt: true,
                  exact: true,
                },
                {
                  text: app.i18n.t('page.events'),
                  disabled: false,
                  to: store.getters['breadcrumbs/hasEventListingRoute']
                    ? search_url
                    : app.localePath({
                        name: 'events',
                      }),
                  nuxt: true,
                  exact: true,
                },
                {
                  text: eventCategory.title,
                  disabled: true,
                  to: app.localePath({
                    name: 'events-category',
                    params: {
                      category: eventCategory.slug,
                    },
                  }),
                  nuxt: true,
                  exact: true,
                },
              ];
              break;

            case 'SectionSeoContent':
              if (
                eventCategory.seo_content_config &&
                eventCategory.seo_content_config.seo_contents &&
                eventCategory.seo_content_config.seo_contents[0]
              ) {
                section.seoContent = await $cachedStrapi.findOne(
                  'seo-contents',
                  eventCategory.seo_content_config.seo_contents[0].id
                );
              } else if (
                section.seo_content_config &&
                section.seo_content_config.seo_contents &&
                section.seo_content_config.seo_contents[0]
              ) {
                section.seoContent = await $cachedStrapi.findOne(
                  'seo-contents',
                  section.seo_content_config.seo_contents[0].id
                );
              }
              break;
          }
        }
      );

      const metaData =
        eventCategory && eventCategory.meta
          ? eventCategory.meta
          : page && page.meta
          ? page.meta
          : {};

      return {
        metaData,
        eventCategory,
        filterParams,
        sections,
      };
    },
    data() {
      return {
        metaData: {},
        eventCategory: {},
        sections: [],

        filterParams: {
          search_term: null,
          categories: [],
        },
      };
    },
    head() {
      return {
        title: this.metaData.title,
        meta: getMetaTags(this.metaData),
      };
    },
    methods: {
      setFilterParams(params) {
        this.filterParams = params;
      },
      resetFilterParams() {
        this.filterParams = {};
        this.page = 1;
      },
    },
  };
